import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useScheme } from '../../hooks/CompanyConfiguration/useScheme'
import AddScheme from './AddScheme'

export default function EditScheme() {
  const { scheme, getScheme } = useScheme()
  const params = useParams()
  useEffect(() => {
    getScheme({ schemeId: params.schemeId })
  }, [params.schemeId])

  return <> {scheme ? <AddScheme scheme={scheme} /> : <Loader />} </>
}
